import { isStandardErrorResponse } from 'src/api/common';
import Auth from 'src/services/api/auth/Auth';
import { AUTH_ERROR_STATUSES, MissingAuthTokenError } from 'src/services/api/auth/auth-errors';
import { simpleKy } from 'src/services/api/ky/simple-ky';

export { MissingAuthTokenError };

/**
 * Extends our simple ky instance with hooks and custom headers.
 *
 * 1. Before each request, it sets the auth headers
 *      Also handles auth token refresh automatically
 * 2. After each response, we redirect the user to the login page if we receive 401 or 422
 */
export const extendedKy = simpleKy.extend({
    hooks: {
        beforeRequest: [
            async (request) => {
                // Refreshing, the both-tokens-gone shortcut and the redirect to
                // login all live in Auth, which the /me fetch shares — see
                // Auth.getRequestAccessToken. It throws MissingAuthTokenError
                // when there is no usable token, which aborts this request: ky
                // rejects with that error and, since nothing was sent, there is
                // no response for afterResponse to mistake for a 401.
                const authHeaders = Auth.getAuthHeaders(await Auth.getRequestAccessToken());

                for (const [key, value] of Object.entries(authHeaders ?? {})) {
                    request.headers.set(key, value);
                }
            },
        ],
        afterResponse: [
            async (_request, _options, response) => {
                if (AUTH_ERROR_STATUSES.includes(response.status)) {
                    Auth.redirectToLoginPage();
                } else if (!response.ok) {
                    const error = await response.json();
                    if (isStandardErrorResponse(error)) {
                        throw error;
                    } else {
                        throw {
                            status: 'error',
                            msg: 'An unknown error occurred',
                        };
                    }
                }
            },
        ],
    },
});
